import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { QuotationFormContainerProps } from "models/propTypes/quotationPropTypes";
//#endregion
//#region  components
import QuotationForm from "./quotationForm";
import useQuotationFormValidations from "./useQuotationFormValidations";
import useQuotationInitialValues from "./useQuotationInitialValues";
//#endregion

const QuotationFormContainer: React.FC<QuotationFormContainerProps> = (props) => {
  const noVatCompany = useSelector((store: AppState) => store.auth.selectedCompany.noVat);
  const hasROT = useSelector((store: AppState) => store.auth.selectedCompany.hasROT);
  const hasRUT = useSelector((store: AppState) => store.auth.selectedCompany.hasRUT);

  const { initialValues, forcedDimensionMap } = useQuotationInitialValues(noVatCompany, props.quotation);

  const validationSchema = useQuotationFormValidations();

  return (
    <QuotationForm
      defaultValues={initialValues}
      validationSchema={validationSchema(forcedDimensionMap)}
      quotation={props.quotation}
      hasROT={hasROT}
      hasRUT={hasRUT}
    />
  );
};

export default QuotationFormContainer;
